import React from 'react';
import { SectionHeader } from '../../components';

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: 'fas fa-check-circle',
      title: 'Proven Results',
      description: 'Track record of delivering measurable growth for our clients'
    },
    {
      icon: 'fas fa-check-circle',
      title: 'Expert Team',
      description: 'Experienced professionals with deep industry knowledge'
    },
    {
      icon: 'fas fa-check-circle',
      title: 'Transparent Communication',
      description: 'Regular updates and clear reporting on all projects'
    },
    {
      icon: 'fas fa-check-circle',
      title: 'Custom Solutions',
      description: 'Tailored strategies that fit your unique business needs'
    }
  ];

  return (
    <section className="section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-right">
            <SectionHeader
              title="Why Choose GrowthVibe?"
              textAlign="text-start"
            />
            <div className="mt-4">
              {reasons.map((reason, index) => (
                <div key={index} className="d-flex align-items-center mb-3">
                  <i className={`${reason.icon} text-primary fa-2x me-3`}></i>
                  <div>
                    <h5 className="mb-1">{reason.title}</h5>
                    <p className="mb-0">{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left">
            <div className="about-image">
              <img 
                src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                alt="GrowthVibe Services" 
                className="img-fluid rounded-3 shadow"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
